import { InjectionToken} from '@angular/core';
import { WebsocketConfig } from '../interfaces/all';

export const WebsocketConfigService = new InjectionToken<WebsocketConfig>('WebsocketContent');
